const QuestionSubType = {
  AutoComplete: "autocomplete",
  Image: "image",
  Emoji: "emoji",
  Select: "select",
  Video: "video", // NOTE: Reserved for future
};

export default QuestionSubType;
